import React from 'react';
import { useNavigate } from "react-router-dom";

import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import UtilisateurAutocomplete from 'components/Shared/UtilisateurAutocomplete';


const AdministrationUtilisateurs = () => {

    const navigate = useNavigate();

    const [utilisateurId, setUtilisateurId] = React.useState(0);

    return (
        <>
            <Typography gutterBottom variant="h5">
                Administration des utilisateurs
            </Typography>

            <Card sx={{ height: 450 }}>
                <CardHeader
                    title={<Typography variant="h6">Choix d'un utilisateur à éditer</Typography>}
                />

                <CardContent>
                    <UtilisateurAutocomplete
                        onChange={id => setUtilisateurId(id)}
                    />
                </CardContent>

                <CardActions sx={{ justifyContent: 'right' }}>
                    <Button
                        disabled={utilisateurId === 0}
                        color="secondary"
                        variant="contained"
                        onClick={() => navigate(`/administration/utilisateurs/${utilisateurId}`)}
                    >
                        Éditer
                    </Button>
                </CardActions>
            </Card>
        </>
    );
};

export default AdministrationUtilisateurs;